import page from '../../../components/page'
import {store} from "../../../store/store";
import {api} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {CommonUtil} from "../../../common/CommonUtil";
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';

export default {
    name: 'entrant',
    data() {
        return {
            activityInfo: null,
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            idS: [],
            totalCount: 0,
            pageCount: 10,
        }
    },
    components: {
        page
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
        store.applicant._this.navName="报名";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.activity.readerApplyeds;
            var data = {
                pageNo: this.pageNo,
                pageCount: this.pageCount,
                idCard: this.idCard
            };
            ajaxUtil.ajaxJson(url, data, "POST", (data) =>  {
                if (data.resultList != null) {
                    this.activityInfo = data.resultList;
                    this.totalCount = data.totalCount;
                    for (var i = 0; i < data.resultList.length; i++) {
                        this.idS.push(data.resultList[i].id);
                    }
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        enterInfo(id) {
            var data = {
                ids: this.idS,
                totalCount: this.totalCount,
                pageCount: this.pageCount,
                pageNo: this.pageNo,
                totalPage: this.totalPage,
            };
            StorageUtil.storeObject("activityInfo", data);
            this.$router.push({path: '/activitydetails', query: {activityId: id, code: this.locationCode}});
        }
    }
}
